import { useFeatureFlagEnabled } from "posthog-js/react";

/** PostHog flag: the Add People dialog in place of the one-at-a-time modals. */
export const useBulkRostering = () =>
  useFeatureFlagEnabled("bulk-rostering") === true;
